<template>
	<page style="background: #fff">
		<c-form ref="form">
			<!-- 基础信息（只读展示） -->
			<c-form-item label="工单号">
				<c-input :value="orderDetail.order_number" disabled></c-input>
			</c-form-item>
			<c-form-item label="客户名称">
				<c-input :value="orderDetail.customer_name" disabled></c-input>
			</c-form-item>
			<c-form-item label="售后网点">
				<c-input :value="orderDetail.after_sale_outlet_name" disabled></c-input>
			</c-form-item>
			<c-form-item label="预计服务时长">
				<c-input :value="orderDetail.estimated_service_days" disabled append-text="天"></c-input>
			</c-form-item>
			<c-form-item label="预计上门人数">
				<c-input :value="orderDetail.estimated_technician_count" disabled append-text="人"></c-input>
			</c-form-item>
			<c-form-item label="是否使用机台">
				<c-input :value="useMachineText" disabled></c-input>
			</c-form-item>
			<c-form-item label="出行方式">
				<c-input :value="travelModeText" disabled></c-input>
			</c-form-item>
			<c-form-item v-if="orderDetail.travel_mode == 2" label="公共交通费用">
				<c-input :value="orderDetail.public_travel_cost" disabled append-text="元"></c-input>
			</c-form-item>
			<c-form-item label="预约日期">
				<c-input :value="orderDetail.appointment_start_time" disabled></c-input>
			</c-form-item>

			<cut-line></cut-line>

			<!-- 售后服务位置（可编辑） -->
			<c-form-item label="客户位置" required>
				<c-location lng-name="customer_address_longitude" lat-name="customer_address_latitude" address-name="customer_address_detail" @updateLngLat="val => endPoint = val"></c-location>
				<template #handle>
					<p v-if="customerDistance" style="font-size: .24rem; color: #999;">
						距客户{{customerDistance}}公里
						<span v-if="customerDuration">（驾车预计耗时：{{durationText}}小时）</span>
					</p>
				</template>
			</c-form-item>

			<!-- 预估成本 -->
			<dl class="expenses">
				<dt class="flex-between-center">
					<p>预估成本：</p>
					<strong>￥{{expensesDetail.estimated_cost_total || '-'}}</strong>
				</dt>
				<dd v-if="expensesDetail.estimated_cost_list && expensesDetail.estimated_cost_list.length">
					<ul>
						<li v-for="(item, i) in expensesDetail.estimated_cost_list" :key="i" class="flex-between-center">
							<span>{{item.fee_type_name}}：</span>
							<span>￥{{item.amount || '-'}}</span>
						</li>
					</ul>
				</dd>
			</dl>
		</c-form>

		<template #button>
			<c-button size="form" color="main" @click="submitHandle">确认提交</c-button>
		</template>
	</page>
</template>

<script>
	import {mapState} from 'vuex';

	export default {
		props: {
			id: String
		},

		data() {
			return {
				startPoint: '',
				endPoint: '',
				customerDistance: 0,
				customerDuration: 0,
				orderDetail: {},
				expensesDetail: {
					estimated_cost_total: '',
					estimated_cost_list: []
				}
			}
		},

		computed: {
			...mapState(['useMachineDic', 'travelModeDic']),

			useMachineText() {
				let item = (this.useMachineDic || []).find(i => i.value == this.orderDetail.use_machine);
				return item ? item.name : '';
			},

			travelModeText() {
				let item = (this.travelModeDic || []).find(i => i.value == this.orderDetail.travel_mode);
				return item ? item.name : '';
			},

			durationText() {
				let sec = parseInt(this.customerDuration);
				return (sec / 3600).toFixed(1);
			}
		},

		watch: {
			startPoint() {
				this.getDistance();
			},

			endPoint() {
				this.getDistance();
			},

			customerDistance() {
				this.calFee();
			}
		},

		mounted() {
			this.request({
				url: '/after/sale/order/detail',
				data: {
					id: this.id
				},
				success: ({detailInfo}) => {
					this.orderDetail = detailInfo;

					this.$refs.form.set({
						customer_address_longitude: detailInfo.customer_address_longitude,
						customer_address_latitude: detailInfo.customer_address_latitude,
						customer_address_detail: detailInfo.customer_address_detail
					});

					if (detailInfo.after_sale_outlet_longitude && detailInfo.after_sale_outlet_latitude) {
						this.startPoint = `${detailInfo.after_sale_outlet_longitude},${detailInfo.after_sale_outlet_latitude}`;
					}
					if (detailInfo.customer_address_longitude && detailInfo.customer_address_latitude) {
						this.endPoint = `${detailInfo.customer_address_longitude},${detailInfo.customer_address_latitude}`;
					}
					this.customerDistance = detailInfo.customer_distance || 0;
					this.customerDuration = detailInfo.customer_duration || 0;
				}
			});
		},

		methods: {
			getDistance() {
				if (!this.startPoint || !this.endPoint) {
					this.customerDistance = 0;
					this.customerDuration = 0;
				} else {
					this.request({
						url: '/location/distance',
						data: {
							longitude1: this.startPoint.split(',')[0],
							latitude1: this.startPoint.split(',')[1],
							longitude2: this.endPoint.split(',')[0],
							latitude2: this.endPoint.split(',')[1]
						},
						success: data => {
							this.customerDistance = data.distance;
							this.customerDuration = data.duration;
						}
					});
				}
			},

			calFee() {
				let d = this.orderDetail;
				let data = {
					use_machine: d.use_machine,
					travel_mode: d.travel_mode,
					estimated_service_days: d.estimated_service_days,
					estimated_technician_count: d.estimated_technician_count,
					public_travel_cost: d.public_travel_cost,
					customer_distance: this.customerDistance || 0
				};
				if (!Object.keys(data).find(key => !data[key] && data[key] !== 0)) {
					this._calFeeRequest && this._calFeeRequest.abort();
					this._calFeeRequest = this.request({
						url: '/after/sale/order/cal/fee',
						data,
						success: data => {
							this.expensesDetail = data;
						}
					});
				}
			},

			submitHandle() {
				this.$refs.form.submit({
					url: '/after/sale/order/edit/location',
					rule: {
						customer_address_longitude: '请选择客户位置',
						customer_address_detail: '请填写客户详细地址'
					},
					dataFormatter: data => {
						data.id = this.id;
						data.customer_distance = this.customerDistance || 0;
						return data;
					},
					success: () => {
						this.$message({
							message: '提交成功',
							mask: true
						});
						setTimeout(() => {
							this.mp.navigateBack();
						}, 1000);
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.expenses {
		border-radius: .16rem;
		padding: 0 .4rem;
		margin-top: .2rem;
		background: #F9F9F9;

		dt {
			height: 1rem;

			p {
				font-size: .32rem;
				font-weight: bold;
			}

			strong {
				font-size: .36rem;
				color: #FF0000;
			}
		}

		dd {
			padding-bottom: .3rem;

			li {
				height: .48rem;
				font-size: .26rem;
				color: #999;
			}
		}
	}
</style>
